import { OAuthRedirect } from './OAuthRedirect';

export const DocuSignOAuthRedirect = () => {
  return <OAuthRedirect provider="DocuSign" apiEndpoint="transformer" authCodePath="authCode" />;
};
